import React from 'react'
import {
  Deck,
  Slide,
  Heading,
  Text,
  DefaultTemplate,
  Box,
  FlexBox,
  SpectacleLogo,
  Notes,
} from 'spectacle'

const deckStyles = {
  width: '100%',
  height: '100%',
  '& > div': {
    position: 'relative',
    height: '100%',
    width: 'auto',
  },
}

const wrapperStyles = {
  maxWidth: '850px',
  aspectRatio: '16 / 9',
  margin: '2rem auto',
  padding: '1rem',
  borderRadius: '12px',
  boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
  backgroundColor: '#fff',
  overflow: 'hidden',
  position: 'relative',
}
const theme = {
  colors: {
    primary: '#344767',
  },
}
export default function SlideDeck({ slides = [] }) {
  return (
    <div style={wrapperStyles}>
      <div style={deckStyles}>
        <Deck
          template={<DefaultTemplate />}
          disableKeyboardControls={false}
          backdropStyle={{
            height: '100%',
            width: 'auto',
            position: 'relative',
          }}
        >
          {slides.map((slide, index) => (
            <Slide key={index} backgroundColor="#344767">
              {slide}
            </Slide>
          ))}
        </Deck>
      </div>
    </div>
  )
}
